import { render, staticRenderFns } from "./OnboardingQuestionDownloadApp.vue?vue&type=template&id=5aa3e235"
import script from "./OnboardingQuestionDownloadApp.vue?vue&type=script&lang=js"
export * from "./OnboardingQuestionDownloadApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports